module.exports = __webpack_public_path__ + "img/txt1.f93f8f04.png";